"use client";
import { NavigationMobile } from "@/widget/navigation/ui/NavigationMobile";
import { I18nProvider } from '@/shared/i18n/I18nProvider';
import KR from '@/shared/i18n/messages/KR.json'
import EN from '@/shared/i18n/messages/EN.json'
import JP from '@/shared/i18n/messages/JP.json'
import VI from '@/shared/i18n/messages/VI.json'
import PullToRefresh from "@/widget/refresh";
import { ChartModalProvider } from "@/widget/chart/model/ChartModalContext";

type Messages = { [k: string]: string | Messages };
const getLanguages = (locale: 'KR' | 'EN' | 'JP' | 'VI'): Messages =>
  locale === 'EN' ? EN : locale === 'JP' ? JP : locale === 'VI' ? VI : KR;


export default function MobileLayoutWrapper({ children }: { children: React.ReactNode }) {
  const locale: 'KR' | 'EN' | 'JP' | 'VI' = 'KR';
  const messages = getLanguages(locale);

  return (
    <PullToRefresh>
      <ChartModalProvider>
        <I18nProvider locale={locale} messages={messages}>
          <div className="mobVer mobile-wrapper mo-py-safe">
            <main className="mo-layout bg-mob-color">{children}</main>
            <NavigationMobile />
          </div>
        </I18nProvider>
      </ChartModalProvider>
    </PullToRefresh>
  )
}
